import { Switch, Flex } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentStep } from "../../redux/selectors";
import { returnToPreviousStep, setCurrentStep } from "../../redux";
import { steps } from "../../util/constants";

export const SMVPreviewModeSwitch = () => {
  const dispatch = useDispatch();
  const step = useSelector(getCurrentStep);

  const handleSwitchChange = (checked) => {
    if (checked) {
      dispatch(setCurrentStep(steps.SMVPreview));
    } else {
      dispatch(returnToPreviousStep());
    }
  };
  return (
    <Flex
      align="center"
      style={{
        position: "absolute",
        margin: "10px 16px",
        zIndex: 500, // to be on top of SMV but below modal
      }}
    >
      <label style={{ cursor: "pointer" }}>
        <Switch
          checked={step === steps.SMVPreview}
          onChange={handleSwitchChange}
        />
        <span style={{ marginLeft: 10 }}> Preview</span>
      </label>
    </Flex>
  );
};
